/* Main styles */
import './css/config.less';
import './css/colors.less';
import './css/utils.less';
import './css/main.less';
import './css/modules/header.less';
import './css/modules/footer.less';

import './css/modules/messages.less';
import './css/modules/login.less';
import './css/modules/list.less';
import './css/modules/menu.less';
import './css/modules/modal.less';
import './css/modules/paginator.less';
import './css/modules/popover.less';
import './css/modules/form.less';

import './css/custom.less';
import './css/main/main.less';

//landing styles
import './css/landing/landing.less';
import './css/landing/landing-edit.less';
import './css/landing/landing-view.less';

import './css/bootstrap/bootstrapCustom.less';

require('bootstrap-toggle');
require('spectrum-colorpicker/spectrum.css');



// WEBPACK FOOTER //
// ./devel/css.js